import {
    CREATE_SALES_ORDER,
    DELETE_SALES_ORDER,
    GET_SALES_ORDERS,
    GET_SALES_ORDERS_PAGE,
    SALES_ORDER_REQUEST,
    SALES_ORDER_REQUEST_SUCCESS,
    SALES_ORDER_REQUEST_FAILURE,
    UPDATE_SALES_ORDER
  } from "../types";
  
  const initialState = {
    salesOrders: [],
    salesOrdersPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const salesOrderReducer = (state = initialState, action) => {
    switch (action.type) {
      case SALES_ORDER_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_SALES_ORDERS: {
        return {
          ...state,
          salesOrders: [...action.payload],
          loading: false,
          error: null
        }
      }
      case SALES_ORDER_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case GET_SALES_ORDERS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          salesOrdersPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_SALES_ORDER:
        return {
          ...state,
          salesOrders: [action.payload, ...state.salesOrders],
          loading: false,
          error: null
        };
      case UPDATE_SALES_ORDER:
        const salesOrdersData = state.salesOrders.slice(0);
        const uIndex = salesOrdersData.findIndex((data) => data.id === action.payload.id);
        salesOrdersData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          salesOrders: [ ...salesOrdersData ],
          loading: false,
          error: null
        };
      case DELETE_SALES_ORDER:
        const salesOrders = state.salesOrders?.slice(0);
        const index = salesOrders.findIndex((data) => data.id === action.id);
        if (index > -1) {
          salesOrders.splice(index, 1);
        }
        return {
          ...state,
          salesOrders: [...salesOrders],
          loading: false,
          error: null
        }
      case SALES_ORDER_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default salesOrderReducer;
  